// extracted by mini-css-extract-plugin
export default {"container":"tema_container__tTaSp","titulo":"tema_titulo__6rWZy"};